<template>
  <tooltip
    class="c-tooltip-link"
    :message="message"
    :position="position"
  >
    <component
      :is="linkType"
      :to="to"
    >
      <slot />
    </component>
  </tooltip>
</template>

<script>
import Tooltip from './Tooltip'
export default {
  components: {
    Tooltip
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    to: {
      type: [Object, String],
      required: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    linkType: {
      type: String,
      default: 'nuxt-link'
    }
  }
}
</script>
